<script>
    import { onMount } from 'svelte';
	import { navigate } from 'svelte-routing';
    import queryString from 'query-string';
    
    const params = queryString.parse(window.location.search);
    const getRedirectLocation = () => {
        switch (params.mode) {
            case 'resetPassword':
                return `/auth/reset-password?code=${params.oobCode}`;
            case 'verifyEmail':
                return `/auth/verify-email?code=${params.oobCode}`;
            default:
                return '/';
        }
    }
    
    onMount(() => {
        navigate(getRedirectLocation(), { replace: true });
    })
</script>